import AppTranslation, { AppTranslationMessage } from "../../../app/AppTranslation";

enum StvVersicherungssumme {
    VS_10MIO = 'VS_10MIO',
    VS_20MIO = 'VS_20MIO'
}

const GOOGLE_TAG_MANAGER_VALUE = new Map();
GOOGLE_TAG_MANAGER_VALUE.set(StvVersicherungssumme.VS_10MIO, 'VS_10MIO');
GOOGLE_TAG_MANAGER_VALUE.set(StvVersicherungssumme.VS_20MIO, 'VS_20MIO');

export function getGoogleTagManagerVsValue(value?: StvVersicherungssumme) {
    if (value && GOOGLE_TAG_MANAGER_VALUE.has(value)) {
        return GOOGLE_TAG_MANAGER_VALUE.get(value);
    }

    return undefined;
}

export function getFormText(value: StvVersicherungssumme) {
    return AppTranslation.getMessage(AppTranslationMessage.APP_MODEL_VERSICHERUNGSSUMME_FORM, value);
}

export function getText(value: StvVersicherungssumme) {
    return AppTranslation.getMessage(AppTranslationMessage.APP_MODEL_VERSICHERUNGSSUMME_TEXT, value);
}

export function getInfoText() {
    return AppTranslation.getMessage(AppTranslationMessage.APP_MODEL_VERSICHERUNGSSUMME_INFO_TEXT);
}

export function getInfoTitel() {
    return AppTranslation.getMessage(AppTranslationMessage.APP_MODEL_VERSICHERUNGSSUMME_INFO_TITEL);
}


export default StvVersicherungssumme;